<template>
    <stepper-layout
        :stepTitle="'Payment Options'"
        :stepIcon="'credit_card'"
        :class="darkMode ? '' : 'pl-1 pt-1'"
    >
        <credit-card
            class="mx-3"
            @reset="reset"
        />
        <v-layout>
            <v-btn
                data-testid="payment-options-return-unit-select-btn"
                class="payment-options-return-unit-select-btn my-3"
                @click="unitSelect"
                :disabled="!recording"
            >
                <v-icon class="mr-2">navigate_before</v-icon>
                Return to Unit Select
            </v-btn>
        </v-layout>
    </stepper-layout>
</template>

<script>
import CreditCard from "@/components/CreditCard";
import StepperLayout from "@/layouts/StepperLayout";
import { mapState } from "vuex";

export default {
  components: { CreditCard, StepperLayout },

  methods: {
    reset() {
      this.$emit("reset");
    },

    unitSelect() {
      this.$emit("unitSelect");
    }
  },

  computed: {
    ...mapState({
      darkMode: state => state.application.settings.darkTheme
    }),
    recording() {
      return this.$store.state.call.recording;
    }
  }
};
</script>

<style scoped>

</style>
